export const isGoogleCalendarPlaceholderHc = (hc?: string | null) =>
  typeof hc === 'string' && hc.trim().toUpperCase().startsWith('GC-');

export const getEffectiveHc = (hc?: string | null) => {
  if (!hc || isGoogleCalendarPlaceholderHc(hc)) return undefined;
  const trimmed = hc.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};
